import React, { useContext, useEffect, useState } from "react";
import DropDownModalStyles from "../../Styles/ChannelViewer/DropDownModal.module.css";
import { ContextForClient } from "../../Context_file/ClientContext";
import Modal from "react-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";

import { postRequest } from "../../helper/CustomPost";
import { fetchRequest } from "../../helper/CustomFetch";
import Input from "../../Common/Input.component/Input";
import DataList from "../../Common/DataLstComponent/DataList";
import Button from "../../Common/Button.component/Button";
import Scrollbar from "react-scrollbars-custom";

Modal.setAppElement("#root");

const JoinChannelModal = () => {
  const [{ joinChannelModal, allChannelsToJoin }, dispatch] =
    useContext(ContextForClient);

  const [channel, setchannel] = useState("");
  const [page, setpage] = useState(0);
  const [limit, setlimit] = useState(0);

  const { main, nav, inputs, pagination, angle } = DropDownModalStyles;

  const customStyle = {
    content: {
      backgroundColor: "#000",
      borderRadius: "20px",
      width: "40%",
      height: "60%",
      minWidth: "300px",
    },
    overlay: {
      position: "absolute",
      zIndex: 10,
    },
  };

  const hideDropDown = async () => {
    await dispatch({ type: "DISPLAY_CHANNELS_TO_JOIN", payload: false });
  };

  const handleSelectChannelToJoin = async (e) => {
    e.preventDefault();
    const url = `joinchannel?channel=${channel}`,
      storage = "newchannel";
    await postRequest({ url, storage, dispatch });
    setchannel("");
    await dispatch({ type: "DISPLAY_CHANNELS_TO_JOIN", payload: false });
  };

  useEffect(() => {
    const url = `allchannel?page=${page}&limit=${limit}`,
      storage = "allchannels";
    fetchRequest({ url, storage, dispatch });
  }, [dispatch, page, limit]);

  const handleNextPagination = () => {
    setpage((prev) => prev + 1);
    setlimit((prev) => prev + 1);
  };

  const handlePreviousPagination = () => {
    if (page < 1 || limit < 1) {
      return;
    }
    setpage((prev) => prev - 1);
    setlimit((prev) => prev - 1);
  };

  return (
    <Modal
      isOpen={joinChannelModal}
      shouldCloseOnEsc={false}
      onRequestClose={() => false}
      style={customStyle}
    >
      <main className={`container ${main}`}>
        <form
          className={`form-group ${nav}`}
          onSubmit={(ref) => handleSelectChannelToJoin(ref)}
        >
          <Input
            name="joinchannel"
            list="joinchannel"
            placeholder="select a channel"
            value={channel}
            onChange={(ref) => setchannel(ref.target.value)}
            className={`form-control ${inputs}`}
          />
          <DataList dataArray={allChannelsToJoin} id="joinchannel" />

          {channel && (
            <div
              className={"mt-2 bg-secondary p-1"}
              style={{ height: channel ? "200px" : "0px" }}
            >
              <Scrollbar>
                <>
                  {allChannelsToJoin &&
                    allChannelsToJoin.map((value, i) => {
                      return value && value.name === channel ? (
                        <p key={i}>{value.description}</p>
                      ) : null;
                    })}
                </>
              </Scrollbar>
            </div>
          )}

          <div className="d-flex justify-content-end w-100">
            <Button
              text="Join"
              width="60%"
              className="btn mt-3 bg-secondary btn-sm"
            />
          </div>
        </form>

        <figure style={{ position: "absolute", top: "5%", right: "3%" }}>
          <FontAwesomeIcon
            icon={faTimesCircle}
            cursor="pointer"
            size="2x"
            color="#fff"
            onClick={() => hideDropDown()}
            title="cancel"
          />
        </figure>

        <figure className={pagination}>
          <FontAwesomeIcon
            icon={faAngleLeft}
            size="lg"
            color="#fff"
            className={angle}
            title="previous"
            onClick={() => handlePreviousPagination()}
          />
          <FontAwesomeIcon
            icon={faAngleRight}
            size="lg"
            color="#fff"
            className={angle}
            title="next"
            onClick={() => handleNextPagination()}
          />
        </figure>
      </main>
    </Modal>
  );
};

export default JoinChannelModal;
